export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8903.8918cc7f.jpg";